import styled from '@emotion/styled';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_SECONDARY};
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const ControlsContainer = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: center;
  gap: 10px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 24px;
`;

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const HeaderButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:hover {
    background-color: ${props => props.disabled ? 'white' : COLORS.PRIMARY};
    color: ${props => props.disabled ? COLORS.PRIMARY : 'white'};
  }
`;

// IDP Card Styles
export const IDPCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 24px;
  padding: 8px 0;
`;

export const IDPCard = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const EmployeeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${COLORS.PRIMARY};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
`;

export const EmployeeDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmployeeName = styled.span`
  font-weight: 600;
  color: #1a1a1a;
  font-size: 14px;
`;

export const EmployeeRole = styled.span`
  color: #6b7280;
  font-size: 12px;
`;

export const GoalTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const TypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.$bgColor || '#f3f4f6'};
  color: ${props => props.$color || '#374151'};
  border: 1px solid ${props => props.$borderColor || '#e5e7eb'};
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.$bgColor || '#f3f4f6'};
  color: ${props => props.$color || '#374151'};
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
`;

export const DateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${props => props.$overdue ? '#dc2626' : '#6b7280'};
  font-size: 13px;
  font-weight: ${props => props.$overdue ? '500' : 'normal'};
`;

export const OverdueAlert = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #fef2f2;
  color: #dc2626;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #fecaca;
  margin-bottom: 12px;
`;

// Progress tracking styles
export const ProgressSection = styled.div`
  margin: 12px 0;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background-color: ${props => props.$color || COLORS.PRIMARY};
  border-radius: 4px;
  transition: width 0.3s ease;
`;

export const ProgressText = styled.span`
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  display: block;
`;

export const RAGIndicator = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${props => props.$color || '#9ca3af'};
  box-shadow: 0 0 0 3px ${props => props.$color ? `${props.$color}33` : '#9ca3af33'};
`;

export const ActionsCount = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #6b7280;
`;

export const SectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 16px 0 8px 0;
`;

export const ActionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }
`;

export const CheckboxIcon = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid ${props => props.$checked ? COLORS.PRIMARY : '#d1d5db'};
  background-color: ${props => props.$checked ? COLORS.PRIMARY : 'white'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
`;

export const ActionText = styled.span`
  font-size: 14px;
  color: ${props => props.$completed ? '#9ca3af' : '#374151'};
  text-decoration: ${props => props.$completed ? 'line-through' : 'none'};
`;

export const ResourceBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  background-color: #f0f9ff;
  color: #0369a1;
  border: 1px solid #bae6fd;
`;
